export default "__VITE_ASSET__DRE1Whm3__";